/* eslint-disable @typescript-eslint/no-explicit-any */
import { ethers } from "ethers";

// 📦 Configuration via Vite env
const RPC_URL = import.meta.env.VITE_RPC_URL;
const CONTROLLER_ADDRESS = import.meta.env.VITE_CONTROLLER_ADDRESS;
const NAU = import.meta.env.VITE_NAU;
const NAUY = import.meta.env.VITE_NAUY;
const NAUN = import.meta.env.VITE_NAUN;

// 📜 ABI minimale
const controllerAbi = ["function getTwapPrice(address) view returns (uint256)"];

/**
 * Récupère les prix TWAP directement depuis le contrat Controller.
 * Retourne des nombres décimaux ou null en cas d’erreur.
 */
export async function fetchPricesOnChain(): Promise<{
  priceNAU: number;
  priceNAUY: number;
  priceNAUN: number;
} | null> {
  if (!RPC_URL || !CONTROLLER_ADDRESS || !NAU || !NAUY || !NAUN) {
    console.error("❌ Missing one or more required env vars.");
    return null;
  }

  try {
    const provider = new ethers.JsonRpcProvider(RPC_URL);
    const contract = new ethers.Contract(
      CONTROLLER_ADDRESS,
      controllerAbi,
      provider
    );

    const safeGet = async (token: string): Promise<number> => {
      try {
        const result = await contract.getTwapPrice(token);
        return Number(ethers.formatUnits(result, 18));
      } catch (err: any) {
        if (err?.reason?.includes("Price data is stale")) {
          console.warn(`⚠️ TWAP price is stale for ${token}`);
          return NaN;
        }
        throw err;
      }
    };

    const [priceNAU, priceNAUY, priceNAUN] = await Promise.all([
      safeGet(NAU),
      safeGet(NAUY),
      safeGet(NAUN),
    ]);

    return { priceNAU, priceNAUY, priceNAUN };
  } catch (err) {
    console.error("❌ fetchPricesOnChain failed:", err);
    return null;
  }
}
